import { mapStationFilterOptionsTo } from '@app/components/stations/advanced-filter';
import { webApi } from '@mi-front/api-clients';
import { StreamQualityReportValues } from './types';

/**
 * Builds the POST body for `/stream-quality/report` from report form values.
 */
export function mapStreamQualityValuesToRequest(
  values: StreamQualityReportValues,
): webApi.StreamQualityReportBodyDto {
  return {
    from: values.dateRange.from ?? '',
    to: values.dateRange.to ?? '',
    stationsFilters: mapStationFilterOptionsTo<
      webApi.StreamQualityReportBodyDto['stationsFilters']
    >(values.stationsFilter ?? []),
  };
}
